import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAngularModule } from '../../modules/mat-angular.module';

export interface Citation {
  id: number;
  title: string;
  url: string;
  snippet: string;
  source?: string;
  domain: string;
  confidence: number;
  type?: string;
  timestamp?: string;
}

@Component({
  selector: 'app-citation-card',
  standalone: true,
  imports: [CommonModule, MatAngularModule],
  templateUrl: './citation-card.component.html',
  styleUrls: ['./citation-card.component.scss']
})
export class CitationCardComponent {
  @Input() citations: Citation[] = [];
  @Input() title: string = 'Sources';
  @Input() displayStyle: 'grid' | 'list' | 'compact' = 'grid';
  @Input() maxDisplay: number = 10;

  expandedCitations: Set<number> = new Set();

  get displayedCitations(): Citation[] {
    return this.citations.slice(0, this.maxDisplay);
  }

  openCitation(url: string): void {
    if (url && url.startsWith('http')) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  toggleExpand(citationId: number): void {
    if (this.expandedCitations.has(citationId)) {
      this.expandedCitations.delete(citationId);
    } else {
      this.expandedCitations.add(citationId);
    }
  }

  isExpanded(citationId: number): boolean {
    return this.expandedCitations.has(citationId);
  }

  getConfidenceColor(confidence: number): string {
    if (confidence >= 0.9) return '#4caf50'; // Green - High confidence
    if (confidence >= 0.8) return '#2196f3'; // Blue - Good confidence
    if (confidence >= 0.7) return '#ff9800'; // Orange - Medium confidence
    return '#f44336'; // Red - Low confidence
  }

  getConfidenceLabel(confidence: number): string {
    if (confidence >= 0.9) return 'High';
    if (confidence >= 0.8) return 'Good';
    if (confidence >= 0.7) return 'Medium';
    return 'Low';
  }

  getFaviconUrl(domain: string): string {
    // Use Google's favicon service or similar
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=32`;
  }

  truncateSnippet(snippet: string, maxLength: number = 150): string {
    if (!snippet) return '';
    if (snippet.length <= maxLength) return snippet;
    return snippet.substring(0, maxLength) + '...';
  }

  trackByCitationId(index: number, citation: Citation): number {
    return citation.id;
  }

  handleImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    if (imgElement) {
      // Use existing favicon from public folder
      imgElement.src = 'favicon.ico';
    }
  }
}

